import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import CreateMeetingRoom from '../components/pages/meeting-room/createMR/content';

function CreateMeetingRoomPage(props) {
  const meetingRoomForm = useSelector((state) => state.meetingRoomReducer.meetingRoomForm);
  const callQualityOptions = useSelector(
    (state) => state.portalSettingReducer.videoQualityProfile.callQualityOptions || []
  );
  const defaultCallQuality = useSelector(
    (state) => state.portalSettingReducer.videoQualityProfile.defaultVideoCallQuality || 0
  );
  const showCreateMeetingRoomModal = useSelector((state) => state.modalReducer.showCreateMeetingRoomModal || false);
  const organisation = useSelector((state) => state.organisationsReducer.selectedOrgUnit);

  const dispatch = useDispatch();

  return (
    <>
      <div>
        <CreateMeetingRoom
          organisation={organisation}
          meetingRoomForm={meetingRoomForm}
          callQualityOptions={callQualityOptions}
          showCreateMeetingRoomModal={showCreateMeetingRoomModal}
          defaultCallQuality={defaultCallQuality}
          changeFilterValue={props.changeFilterValue}
          searchOnEntityPage={props.searchOnEntityPage}
          dispatch={dispatch}
        />
      </div>
    </>
  );
}

export default CreateMeetingRoomPage;
